import { useState } from 'react'
import { BookText } from 'lucide-react'
import { parse } from 'path-browserify'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Skeleton } from '@/components/ui/skeleton'
import { Button } from '@/components/ui/button'
import { useDocs } from '@/features/docs/api/getDocs'

export const DocsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { data, isLoading } = useDocs({
    queryConfig: {
      enabled: isOpen,
    },
  })

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="secondary" size="icon">
          <BookText />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="start" sideOffset={10}>
        <DropdownMenuLabel>Help documents</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {isLoading ? (
          Array.from({ length: 5 }).map((_, index) => <Skeleton key={index} className="h-[26px] my-1 w-full" />)
        ) : !data ? (
          <DropdownMenuItem>No document found</DropdownMenuItem>
        ) : (
          data?.map((doc) => (
            <a key={doc.url} href={doc.url} target="_blank">
              <DropdownMenuItem className="cursor-pointer">{parse(doc.name).name}</DropdownMenuItem>
            </a>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
